export default "__VITE_ASSET__CbhWZVV$__"